import { responsiveVariables } from "../../utilities/props.js";
import "./position.css";
const getPositionStyles = (value) => {
    if (!value)
        return null;
    const variables = responsiveVariables("--rs-position", value);
    return { variables };
};
export default getPositionStyles;
